import { Component, OnInit, SkipSelf } from '@angular/core';
import { NgbActiveModal, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { FireflyMobileModalComponent, ModalContent } from '../../modal';

@Component({
  selector: 'f-mobile-dropdown',
  template: '',
  standalone: false
})
export class FireflyMobileDropdownComponent implements OnInit, ModalContent {
  readonly context!: {
    dropdownMenu: NgbDropdownMenu;
    mobileShowAcceptBtn: boolean;
  };
  modalInstance!: NgbActiveModal;

  constructor(@SkipSelf() private modalContainer: FireflyMobileModalComponent) {}

  ngOnInit() {
    if (!this.context.mobileShowAcceptBtn) this.modalContainer.toggleAcceptBtnVisibility(false);
    this.modalContainer.modalBody.nativeElement.prepend(this.context.dropdownMenu.nativeElement);
    this.context.dropdownMenu.dropdown.openChange.pipe(take(1)).subscribe(isOpen => {
      if (!isOpen) {
        this.modalContainer.modalBody.nativeElement.prepend(this.context.dropdownMenu.nativeElement.cloneNode(true));
        this.modalInstance.close();
      }
    });
  }
}
